// extracted by mini-css-extract-plugin
module.exports = {"min-quantity":"_1REMSq","know-more":"_3T52Ou","blink":"_1B0GOL","blinkBackground":"_1tZmGy","highlight":"_2g1w_R","moq-info-modal":"_2xmQ0b"};